import React from 'react';
import { useLanguage } from '../../i18n/LanguageContext';

const IngredientList = ({ ingredients }) => {
  const { t } = useLanguage();
  const rd = t.recipeDetail;

  if (!ingredients || !ingredients.length) {
    return (
      <section className="recipe-ingredients">
        <h3>{rd.ingredientsTitle}</h3>
        <p className="empty-copy">{rd.ingredientsFallback}</p>
      </section>
    );
  }

  return (
    <section className="recipe-ingredients">
      <h3>{rd.ingredientsTitle}</h3>
      <ul>
        {ingredients.map((ingredient, index) => (
          <li key={`${ingredient.name || 'ingredient'}-${index.toString()}`}>
            <div className="ingredient-line">
              <span className="ingredient-name">{ingredient.name || 'Ingredient'}</span>
              {ingredient.quantity ? <span className="ingredient-quantity">{ingredient.quantity}</span> : null}
            </div>
            {ingredient.healthyAlternatives?.length ? (
              <p className="ingredient-alt">
                <span>{rd.healthyAlt}</span> {ingredient.healthyAlternatives.join(', ')}
              </p>
            ) : null}
          </li>
        ))}
      </ul>
    </section>
  );
};

export default IngredientList;
